import { BLOCK_REGISTRY } from "../blockRegistry";

const ABOUT_US_DEFAULT_BLOCKS = [
  { id: "default-about-hero", type: "about-hero" },
  { id: "default-about-stats", type: "about-stats" },
  { id: "default-about-story", type: "about-story" },
  { id: "default-about-values", type: "about-values" },
].map((block) => ({
  ...block,
  fields: BLOCK_REGISTRY[block.type].defaultFields,
}));

export default ABOUT_US_DEFAULT_BLOCKS;
